<div class="wm-card2">
  <wm-rw-text2 name="Company Name" [(ngModel)]="company" (ngModelChange)="internalModelChange()" [mode]="Mode.Write" />
  <wm-rw-text2 name="First Name" [required]="true" [(ngModel)]="firstName" (ngModelChange)="internalModelChange()" [mode]="Mode.Write" />
  <wm-rw-text2 name="Last Name" [required]="true" [(ngModel)]="lastName" (ngModelChange)="internalModelChange()" [mode]="Mode.Write" />
  <wm-rw-text2 name="Main Phone" [required]="true" [(ngModel)]="mainPhone" (ngModelChange)="internalModelChange()" [mode]="Mode.Write" />
  <wm-rw-text2 name="Mobile Phone" [(ngModel)]="mobilePhone" (ngModelChange)="internalModelChange()" [mode]="Mode.Write" />
</div>
